/**
 * Efetua download de um arquivo, pdf, docx etc.
 * @param blob O arquivo em formato de buffer para blob.
 * @param filename Nome do arquivo, se não informado é gerado um UUID aleatório.
 */
export function DownloadFileFromDatabaseBlob(blob: any, filename?: string) {
  const url = window.URL.createObjectURL(blob);

  const link = document.createElement('a');
  link.href = url;
  link.download = filename ? filename : `${generateUUID()}.pdf`;

  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  window.URL.revokeObjectURL(url);
}

function generateUUID() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    const r = (Math.random() * 16) | 0;
    const v = c === 'x' ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}
